import { faBookmark, faComment } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faTwitter, faWhatsapp, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const AiEverydayLife = () => {
  return (
    <div className="bg-[#fff] w-full flex flex-col">
      <section
        style={{ backgroundImage: `url('../images/ai-everyday-life.jpg')`, backgroundSize: "100% 60vh" }}
        className="hero--container relative flex flex-col justify-center w-full h-[60vh] bg-no-repeat bg-fixed md:bg-origin-border pt-[65px]">
        <p className="text-white p-1.5 rounded-md text-xs font-bold text-center mb-10 bg-blue-500 mx-auto">
          AI, Everyday Life
        </p>
        <h1 className="text-center text-white text-2xl md:text-5xl font-bold uppercase leading-9">
          AI-Powered Tools for Everyday Life
        </h1>

        <div className="flex justify-center items-center gap-4 mt-10">
          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faClock} className="w-4" />
            <p className="blog-publish-date">28/01/2025</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faComment} className="w-4" />
            <p className="blog-publish-date">15 Comments</p>
          </div>

          <div className="flex items-center gap-2 text-white">
            <FontAwesomeIcon icon={faBookmark} />
            <p className="blog-publish-date">3000 Views</p>
          </div>
        </div>
      </section>

      <section className="body--container w-full px-4 py-8 md:py-10 md:px-12 lg:px-16 xl:px-20 2xl:px-24">
        <div className="mx-auto max-w-screen-md">
          <p className="pb-4 text-justify leading-7">
            Artificial intelligence (AI) has seamlessly integrated into our daily lives, transforming the way we work, learn, and interact with technology. From personalized recommendations to virtual assistants, AI-powered tools are simplifying tasks and boosting productivity.
          </p>

          <img src="../images/ai-everyday-life.jpg" alt="AI Everyday Life" className="mx-auto mt-3 mb-6 w-full" />

          <p className="pb-4 text-justify leading-7">
            Virtual assistants like Siri, Alexa, and Google Assistant have become essential for managing schedules, setting reminders, and answering queries. Their natural language processing capabilities enable them to understand and respond to user commands efficiently.
          </p>

          <p className="pb-4 text-justify leading-7">
            AI-driven recommendation systems, found on platforms like Netflix and Spotify, enhance user experiences by analyzing preferences and suggesting content tailored to individual tastes. These systems save time and make entertainment more enjoyable.
          </p>

          <p className="pb-4 text-justify leading-7">
            In the workplace, AI-powered tools like Grammarly and Notion are revolutionizing productivity. Grammarly assists with grammar and writing style corrections, while Notion combines note-taking and task management into a single, streamlined platform.
          </p>

          <p className="pb-4 text-justify leading-7">
            ChatGPT and other conversational AI tools have become invaluable for brainstorming, drafting content, and solving problems. These tools leverage natural language understanding to provide instant, coherent responses, making them a go-to for creative and technical tasks alike.
          </p>

          <p className="pb-4 text-justify leading-7">
            Healthcare has also seen significant advancements with AI. Wearable devices like smartwatches monitor health metrics such as heart rate and sleep patterns, providing users with actionable insights to improve their well-being.
          </p>

          <p className="pb-4 text-justify leading-7">
            Despite its benefits, AI raises concerns about data privacy and ethical usage. Balancing innovation with responsible implementation is crucial for building trust in AI technologies.
          </p>

          <p className="pb-4 text-justify leading-7">
            As AI continues to evolve, its role in everyday life will only grow. By leveraging these powerful tools, individuals and organizations can achieve greater efficiency, creativity, and convenience.
          </p>
        </div>
      </section>

      <section className="mb-8">
        <div className="max-w-screen-md mx-auto rounded-md flex justify-between items-center gap-6">
          <div className="flex flex-wrap gap-2">
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">AI</p>
            <p className="bg-gray-200 text-gray-600 px-2 py-1 rounded-md">Productivity</p>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center bg-[#42599E] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faFacebook} /> share
              </a>
            </div>
            <div className="flex items-center bg-[#55ACEE] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://twitter.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faTwitter} /> tweet
              </a>
            </div>
            <div className="flex items-center bg-[#34AF23] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.whatsapp.com" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} /> whatsapp
              </a>
            </div>
            <div className="flex items-center bg-[#0798CF] p-4 rounded-lg text-white mb-2 max-h-1">
              <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon icon={faLinkedin} /> linkedin
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AiEverydayLife;